/**
 * RendPleX Scenario Analyzer 2.0 — P1A pure delta computation.
 *
 * ZERO financial math lives here beyond subtraction. Both `original`
 * and `current` MUST already be canonical metric objects returned by
 * POST /api/scenario/calculate. Any duplication of mortgage / NOI /
 * cap-rate arithmetic is a P1 contract violation.
 */

/** Keys we surface in Financial Impact (canonical /calculate output). */
export const FINANCIAL_IMPACT_KEYS = [
  'monthly_cash_flow',
  'annual_cash_flow',
  'noi',
  'cap_rate',
  'dscr',
  'roi',
  'cash_on_cash',
  'monthly_mortgage',
];

/**
 * Return { <key>: {original, current, delta, deltaPct} } for the
 * whitelisted keys. `null` values are preserved (e.g., DSCR when
 * unfinanced) and produce a `null` delta rather than a bogus zero.
 */
export function diffMetrics(current, original) {
  const out = {};
  if (!current || !original) return out;
  for (const k of FINANCIAL_IMPACT_KEYS) {
    const o = original[k];
    const c = current[k];
    if (o === null || o === undefined || c === null || c === undefined) {
      out[k] = { original: o ?? null, current: c ?? null, delta: null, deltaPct: null };
      continue;
    }
    const delta = c - o;
    const deltaPct = o !== 0 ? (delta / Math.abs(o)) * 100 : null;
    out[k] = { original: o, current: c, delta, deltaPct };
  }
  return out;
}
